import { render, staticRenderFns } from "./Seguros.vue?vue&type=template&id=51c5ee67&scoped=true"
import script from "./Seguros.vue?vue&type=script&lang=js"
export * from "./Seguros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c5ee67",
  null
  
)

export default component.exports